import {BasicProps} from "../Main";
import React, {useEffect, useState} from "react";
import {
    Grid,
    Collapse,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, MenuItem, Checkbox, FormControlLabel, useMediaQuery
} from "@mui/material";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import SamaggiPaper from "../Components/SamaggiPaper";
import {SamaggiDate, SamaggiField, SamaggiSelect} from "../Components/SamaggiFields";
import {SamaggiButton} from "../Components/SamaggiButton";
import axios from "axios";
import {handleError} from "../support";
import {useNavigate} from "react-router-dom";
import AWS from "aws-sdk";
import {v4 as UUIDv4} from "uuid";
import Typography from "@mui/material/Typography";
import theme from "../theme";

interface LooseObject {
    [key: string]: any
}


export function truncate(input: string, n: number = 12) {
    if (input.length > n) {
        return input.substring(0, n) + '...';
    }
    return input;
}

export const Reimbursements: React.FC<BasicProps> = (props) => {

    const [userID, setUserID] = useState("");

    const [rows, setRows] = useState<Array<ReturnType<typeof createData>>>([]);

    const [file, setFile] = useState();
    const [fileName, setFileName] = useState("");

    const [action, setAction] = useState("NEW");
    const [category, setCategory] = useState("");
    const [amount, setAmount] = useState("0");
    const [currency, setCurrency] = useState("GBP");
    const [description, setDescription] = useState("");
    const [skip, setSkip] = useState(false);
    const [date, setDate] = useState(new Date());

    const [request, setRequest] = useState("");
    const [finalAmount, setFinalAmount] = useState("0");

    const [bankData, setBankData] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const [sort, setSort] = useState("L");

    const navigate = useNavigate();
    const vertical = useMediaQuery(theme.breakpoints.down("sm"));

    function createData(
        id: string,
        time: number,
        category: string,
        description: string,
        amountDisplay: string,
        statusDisplay: string,
        reimbursementStatus: string,
        requestStatus: string,
        validForReimbursement: boolean,
        paymentDate: string,
        path1: string,
        path2: string,
        amount: number,
        currency: string,
        notes: string,
        bankAccount: string,
        requestDecisionTime: number,
        reimbursementDecisionTime: number,
        paidTime: number,
        reimbursementRequestTime: number
    ) {
        return {
            id,
            time,
            category,
            description,
            amountDisplay,
            statusDisplay,
            reimbursementStatus,
            requestStatus,
            validForReimbursement,
            paymentDate,
            path1,
            path2,
            amount,
            currency,
            notes,
            bankAccount,
            requestDecisionTime,
            reimbursementDecisionTime,
            paidTime,
            reimbursementRequestTime
        };
    }

    function load() {
        const token = localStorage.getItem("token");

        props.setShowCover(true);

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/finance/init", {"token": token}).then((res) => {
            console.log(res);
            props.setShowCover(false);

            setBankData(res.data.data.bankData);
            setUserID(res.data.data.userID);

            const data: Array<ReturnType<typeof createData>> = [];

            res.data.data.data.forEach((value: any) => {
                data.push(createData(
                    value["id"],
                    value["submittedTime"],
                    value["category"],
                    value["description"],
                    value["amountDisplay"],
                    value["statusDisplay"],
                    value["reimbursementStatus"],
                    value["requestStatus"],
                    value["validForReimbursement"],
                    value["paymentDate"],
                    value["path1"],
                    value["path2"],
                    value["amount"],
                    value["currency"],
                    value["notes"],
                    value["bankAccount"],
                    parseFloat(value["requestDecisionTime"]),
                    parseFloat(value["reimbursementDecisionTime"]),
                    parseFloat(value["paidTime"]),
                    parseFloat(value["reimbursementRequestTime"])
                ))
            })

            setRows(data);
        }).catch((error) => {
            props.setShowCover(false);

            handleError(error, true);
        })
    }

    async function uploadFile() {
        const bucketName = "samaggi-reimbursements";
        const bucketRegion = "eu-west-2";
        const IdentityPoolId = "eu-west-2:61d99022-f435-4358-aa09-04eb35257915";

        AWS.config.update({
            region: bucketRegion,
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: IdentityPoolId
            })
        });

        if (file === undefined && (((!needRequest() || skip) && action === "NEW") || action === "EXISTING")) {
            alert("Please choose a file.");
            return
        } else if (file === undefined && needRequest() && !skip && action === "NEW") {
            submit("");
            return
        }

        const re = /(?:\.([^.]+))?$/;
        const regex = re.exec(fileName)

        if (regex === null) {
            alert("Failed to get file name.")
            return
        }

        let fileExt = regex[1];

        if (fileExt === undefined) {
            fileExt = ".jpg";
        }

        const key = encodeURI(`${userID}/${UUIDv4().toString().replaceAll("-", "").slice(0, 14)}.${fileExt}`);

        const upload = new AWS.S3.ManagedUpload({
            params: {
                Bucket: bucketName,
                Key: key,
                Body: file
            }
        });

        const uploadPromise = upload.promise();

        props.setShowCover(true);

        uploadPromise.then(
            () => submit(key),
            function(err) {
                alert(err);
                props.setShowCover(false);
                return alert("There was an error uploading your file: " + err.message);
            }
        );
    }

    function submit(path: string) {
        const token = localStorage.getItem("token");

        if (action === "NEW") {
            let data: LooseObject;

            if (!needRequest() || skip) {
                data = {
                    "token": token,
                    "category": category,
                    "amount": parseFloat(amount),
                    "currency": currency,
                    "description": description,
                    "path": path,
                    "paymentDate": date.toString(),
                    "bankAccount": selectedBank,
                    "skipped": skip,
                }

                if ([category, parseFloat(amount), currency, description, path, date.toString(), selectedBank].some((x) => x === "" || x === 0)) {
                    alert("You may not leave any field blank.");
                    return
                }
            } else {
                data = {
                    "token": token,
                    "category": category,
                    "amount": parseFloat(amount),
                    "currency": currency,
                    "description": description,
                    "path": path
                }

                if ([category, parseFloat(amount), currency, description].some((x) => x === "" || x === 0)) {
                    alert("You may not leave any field blank.");
                    return
                }
            }

            axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/finance/submit", data).then((res) => {
                console.log(res);
                load()

                setCategory("");
                setAmount("0");
                setCurrency("GBP");
                setDescription("");
                setDate(new Date());
                setSelectedBank("");
                setSkip(false);
                setFile(undefined);
                setFileName("");

            }).catch((error) => {
                props.setShowCover(false);
                alert("Submission Failed.");

                handleError(error, true);
            })
        } else {
            const data = {
                "token": token,
                "requestID": request,
                "newAmount": parseFloat(finalAmount),
                "bankAccount": selectedBank,
                "notes": description,
                "date": date.toString(),
                "path": path
            }

            if ([request, parseFloat(finalAmount), description, selectedBank, date.toString(), path].some((x) => x === "" || x === 0)) {
                alert("You may not leave any field blank.");
                return
            }

            axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/finance/update", data).then((res) => {
                console.log(res);
                load()

                setCategory("");
                setFinalAmount("0");
                setRequest("");
                setCurrency("GBP");
                setDescription("");
                setDate(new Date());
                setSelectedBank("");
                setSkip(false);
                setFile(undefined);
                setFileName("");

            }).catch((error) => {
                props.setShowCover(false);
                alert("Submission Failed.");

                handleError(error, true);
            })
        }

    }

    useEffect(() => {
        load() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function needRequest() {
        return ((parseFloat(amount) > 15 && currency === "GBP") || (parseFloat(amount) > 600 && currency === "THB") || (parseFloat(amount) > 20 && currency === "USD"))
    }

    function dateFromEpoch(v: number) {
        const d = new Date(0);
        d.setUTCSeconds(v);
        return d
    }

    function Row(props: { row: ReturnType<typeof createData> }) {
        const { row } = props;
        const [open, setOpen] = useState(false);

        return (
            <React.Fragment>
                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                    <TableCell align={"center"} sx={{padding: 0}}>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                            sx={{padding: "2px"}}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell align={"center"} component="th" scope="row" sx={{padding: "2px"}}>
                        {row.category}
                    </TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{truncate(row.description)}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.amountDisplay}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px", fontWeight: 600, color: (row.statusDisplay.includes("APPROVED") || row.statusDisplay.includes("PAID")) ? "#008600" : (row.statusDisplay.includes("REJECTED") ? "#a80000" : "#000000")}}>{row.statusDisplay}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit sx={{paddingLeft: 0, paddingRight: 0, paddingTop: 5, paddingBottom: 5}}>
                            <Grid container direction={"column"} spacing={4}>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            General
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>ID: </SamaggiTypography>{row.id}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Description: </SamaggiTypography>{row.description}</SamaggiTypography>
                                    </Grid>
                                    {row.notes !== "" && <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Additional Notes: </SamaggiTypography>{row.notes}</SamaggiTypography>
                                    </Grid>}
                                    {row.bankAccount !== "" && <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Bank Account: </SamaggiTypography>{row.bankAccount.split("//")[2]} {row.bankAccount.split("//")[3]}</SamaggiTypography>
                                    </Grid>}
                                </Grid>
                                <Grid item container direction={"column"} spacing={3}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Request Status
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">Expense Approval</TableCell>
                                                        <TableCell align="center">{vertical ? "Reimb." : "Reimbursement"}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                        <TableCell align="center" sx={{padding: 0, paddingTop: "10px", paddingBottom: "10px",fontWeight: row.requestStatus !== "NOT NEEDED" ? 600 : 400, color: row.requestStatus.includes("APPROVED") ? "#008600" : row.requestStatus.includes("REJECTED") ? "#a80000" : "#000000"}}>
                                                            <>
                                                                {row.requestStatus}<br/>
                                                                {row.requestDecisionTime !== 0 ? dateFromEpoch(row.requestDecisionTime).toLocaleString() : dateFromEpoch(row.time).toLocaleString()}
                                                            </>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{padding: 0, paddingTop: "10px", paddingBottom: "10px",fontWeight: row.reimbursementStatus === "REQUESTED" ? 600 : 400}}>
                                                            <>
                                                                {row.reimbursementStatus === "NOT REQUESTED" ? "NOT REQUESTED" : "REQUESTED"}<br/>
                                                                {row.reimbursementRequestTime !== 0 ? dateFromEpoch(row.reimbursementRequestTime).toLocaleString() : ""}
                                                            </>
                                                        </TableCell>
                                                    </TableRow>
                                                    {["APPROVED", "REJECTED", "PAID"].includes(row.reimbursementStatus) && (
                                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                            <TableCell/>
                                                            <TableCell align="center" sx={{padding: 0, paddingTop: "10px", paddingBottom: "10px",fontWeight: ["APPROVED", "REJECTED"].includes(row.reimbursementStatus) ? 600 : 400, color: (row.reimbursementStatus === "APPROVED" || row.reimbursementStatus === "PAID") ? "#008600" : "#a80000"}}>
                                                                <>
                                                                    {row.reimbursementStatus === "PAID" ? "APPROVED" : row.reimbursementStatus}<br/>
                                                                    {row.reimbursementDecisionTime !== 0 ? dateFromEpoch(row.reimbursementDecisionTime).toLocaleString() : ""}
                                                                </>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {row.reimbursementStatus === "PAID" && (
                                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                            <TableCell/>
                                                            <TableCell align="center" sx={{padding: 0, paddingTop: "10px", paddingBottom: "10px",fontWeight: row.reimbursementStatus === "PAID" ? 600 : 400, color: "#008600"}}>
                                                                <>
                                                                    {"PAID"}<br/>
                                                                    {row.paidTime !== 0 ? dateFromEpoch(row.paidTime).toLocaleString() : ""}
                                                                </>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Payment Date: </SamaggiTypography>{row.paymentDate !== null && row.paymentDate.length > 0 ? row.paymentDate : "Not Paid"}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Date Submitted: </SamaggiTypography>{dateFromEpoch(row.time).toLocaleString()}</></SamaggiTypography>
                                    </Grid>
                                </Grid>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Files
                                        </SamaggiTypography>
                                    </Grid>
                                    {row.path1 !== "" && <Grid item>
                                        <SamaggiButton fullWidth onClick={() => {window.open(row.path1, "_blank")}}>View Uploaded Supporting File</SamaggiButton>
                                    </Grid>}
                                    {row.path2 !== "" && <Grid item>
                                        <SamaggiButton fullWidth onClick={() => {window.open(row.path2, "_blank")}}>View Uploaded Proof of Purchase</SamaggiButton>
                                    </Grid>}
                                </Grid>
                            </Grid>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    function handleFileChange(e: any) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            setFileName(e.target.files[0].name);
        }
    }

    function handleRequestChange(id: string) {
        const data = rows.filter((item) => item.id === id)[0] as ReturnType<typeof createData>
        setCurrency(data.currency);
        setFinalAmount(data.amount.toString());
        setRequest(id);
    }

    return (
        <Grid container direction={"column"} spacing={2}>
            <Grid item>
                <SamaggiSelect label={"Sort By"} value={sort} onChange={(e) => {setSort(e.target.value as string)}}>
                    <MenuItem value={"L"}>Latest</MenuItem>
                </SamaggiSelect>
            </Grid>
            <Grid item>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" size={"small"}>
                        <TableHead>
                            <TableRow>
                                <TableCell/>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Cat." : "Category"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Desc." : "Description"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Amt." : "Amount"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Stat." : "Status"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.sort((a,b) => b.time - a.time).map((row) => (
                                <Row key={row.time} row={row} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item>
                <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {props.setShowCover(true); load()}}>Reload</SamaggiButton>
            </Grid>
            <Grid item>
                <SamaggiPaper style={{width: "97%"}}>
                    <Grid container direction={"column"} spacing={2}>
                        <Grid item>
                            <SamaggiSelect value={action} onChange={(e) => {setAction(e.target.value as string)}} label={"Action"}>
                                <MenuItem value={"NEW"}>New Expense Request</MenuItem>
                                <MenuItem value={"EXISTING"}>Reimbursement for Existing Expense Request</MenuItem>
                            </SamaggiSelect>
                        </Grid>
                        {action === "NEW" && <>
                            <Grid item>
                                <SamaggiSelect value={category} onChange={(e) => {setCategory(e.target.value as string)}} label={"Payment Category"}>
                                    <MenuItem value={"T"}>Transport/Travel</MenuItem>
                                    <MenuItem value={"M"}>Meetings-Related</MenuItem>
                                    <MenuItem value={"O"}>Others</MenuItem>
                                </SamaggiSelect>
                            </Grid>
                            <Grid item container direction={"row"} spacing={2}>
                                <Grid item xs={6}>
                                    <SamaggiField label={"Amount"} value={amount} inputProps={{maxLength: 13, step: ".01"}} onChange={(e) => {setAmount(e.target.value)}} type={"number"}/>
                                </Grid>
                                <Grid item xs={6}>
                                    <SamaggiSelect label={"Currency"} value={currency} onChange={(e) => {setCurrency(e.target.value as string)}}>
                                        <MenuItem value={"GBP"}>GBP</MenuItem>
                                        <MenuItem value={"THB"}>THB</MenuItem>
                                        <MenuItem value={"USD"}>USD</MenuItem>
                                    </SamaggiSelect>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <SamaggiField label={"Description of Payment"} value={description} onChange={(e) => {setDescription(e.target.value)}} type={"text"}/>
                            </Grid>
                            {(!needRequest() || skip) && <Grid item>
                                <SamaggiDate label={"Payment Date"} value={date} onChange={(e) => setDate((e === null) ? new Date() : e)}/>
                            </Grid>}
                            <Grid item container direction={"column"} spacing={2}>
                                <Grid item>
                                    <Typography sx={{fontWeight: "600"}}>{needRequest() ? "Supporting Document (Optional)" : "Receipt/Proof of Purchase"}</Typography>
                                </Grid>
                                <Grid item>
                                    <input type={"file"} accept="image/png, image/jpeg, application/pdf" id="file-upload" onChange={(e) => {handleFileChange(e)}} />
                                </Grid>
                            </Grid>
                            {(!needRequest()) &&
                                <Grid item>
                                    <SamaggiTypography xsmall center>You do not need to make an expense approval request for this payment. Click below to request reimbursement.</SamaggiTypography>
                                </Grid>
                            }
                            {(!needRequest() || skip) &&
                                <Grid item>
                                    <SamaggiSelect label={"Bank Account"} value={selectedBank} onChange={(e) => {setSelectedBank(e.target.value as string)}}>
                                        {bankData.map((item) => (
                                            <MenuItem value={`${item["id"]}//${item["account-number"]}//${item["country"] === "THA" ? item["bank-name"] : item["sort-code"]}`}>{item["account-number"]} — {item["country"] === "THA" ? item["bank-name"] : item["sort-code"]} — {item["country"] === "THA" ? "Thailand" : "United Kingdom"}</MenuItem>
                                        ))}
                                    </SamaggiSelect>
                                </Grid>
                            }
                            {needRequest() && <Grid item>
                                <FormControlLabel style={{color: "#c42727", fontStyle: "italic"}} control={<Checkbox color={"error"} sx={{color: "#c42727"}} onChange={(e) => {setSkip(e.target.checked); if (e.target.checked) {alert("Skipping approval request for this payment is against Samaggi Samagom's policy. Only use this option if you have had prior communication with the Finance department.")}}}></Checkbox>} label={"Skip Approval Request"}/>
                            </Grid>}
                            <Grid item>
                                <SamaggiButton fullWidth onClick={() => {uploadFile()}}>{(needRequest() && !skip) ? "Request Expense Approval": "Request Reimbursement"}</SamaggiButton>
                            </Grid>
                        </>}
                        {action === "EXISTING" && <>
                            <Grid item>
                                <SamaggiSelect label="Request" value={request} onChange={(e) => {handleRequestChange(e.target.value as string)}}>
                                    {rows.filter((item) => item.validForReimbursement).sort((a,b) => b.time - a.time).map((item) =>
                                        <MenuItem value={item.id}>{truncate(item.id, 15)} — {truncate(item.description, 15)}</MenuItem>
                                    )}
                                </SamaggiSelect>
                            </Grid>
                            <Grid item container direction={"row"} spacing={2}>
                                <Grid item xs={6}>
                                    <SamaggiField label={"Final Amount"} value={finalAmount} inputProps={{maxLength: 13, step: ".01"}} onChange={(e) => {setFinalAmount(e.target.value)}} type={"number"}/>
                                </Grid>
                                <Grid item xs={6}>
                                    <SamaggiSelect disabled label={"Currency"} value={currency}>
                                        <MenuItem value={"GBP"}>GBP</MenuItem>
                                        <MenuItem value={"THB"}>THB</MenuItem>
                                        <MenuItem value={"USD"}>USD</MenuItem>
                                    </SamaggiSelect>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <SamaggiTypography xsmall italic center>Final payment amount must be less than or equals to the requested amount.</SamaggiTypography>
                            </Grid>
                            <Grid item>
                                <SamaggiField label={"Additional Notes"} value={description} onChange={(e) => {setDescription(e.target.value)}} type={"text"}/>
                            </Grid>
                            <Grid item>
                                <SamaggiDate label={"Payment Date"} value={date} onChange={(e) => setDate((e === null) ? new Date() : e)}/>
                            </Grid>
                            <Grid item container direction={"column"} spacing={2}>
                                <Grid item>
                                    <Typography sx={{fontWeight: "600"}}>Receipt/Proof of Purchase</Typography>
                                </Grid>
                                <Grid item>
                                    <input type={"file"} accept="image/png, image/jpeg, application/pdf" id="file-upload" onChange={(e) => {handleFileChange(e)}} />
                                </Grid>
                            </Grid>
                            <Grid item>
                                <SamaggiSelect label={"Bank Account"} value={selectedBank} onChange={(e) => {setSelectedBank(e.target.value as string)}}>
                                    {bankData.map((item) => (
                                        <MenuItem value={`${item["id"]}//${item["account-number"]}//${item["country"] === "THA" ? item["bank-name"] : item["sort-code"]}//${item["country"]}`}>{item["account-number"]} — {item["country"] === "THA" ? item["bank-name"] : item["sort-code"]} — {item["country"] === "THA" ? "Thailand" : "United Kingdom"}</MenuItem>
                                    ))}
                                </SamaggiSelect>
                            </Grid>
                            <Grid item>
                                <SamaggiButton fullWidth onClick={() => {uploadFile().then(r => {console.log(`Uploaded ${r}`)})}}>Request Reimbursement</SamaggiButton>
                            </Grid>
                        </>}
                    </Grid>
                </SamaggiPaper>
            </Grid>
            <Grid item>
                <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {navigate("/")}}>Back to Staff Portal</SamaggiButton>
            </Grid>
        </Grid>
    );
}
